import {
  Button,
  CloseButton,
  Dialog,
  Flex,
  Portal,
  Text,
} from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router';
import useStartExecution from '@App/CampaignExecution/hooks/useStartExecution';
import useCheckMyDispositions from '@hooks/useCheckMyDispositions';
import CustomDialogBackdrop from '@components/CustomDialogBackdrop';

type Props = {
  handleClose: () => void;
  afterSubmit: () => void;
};

const ConfirmNextCampaignExecutionDialog = ({ handleClose, afterSubmit }: Props) => {
  const navigate = useNavigate();

  const { executionId } = useParams() as { executionId: string };

  const { onStartExecution, loading: startingExecution } = useStartExecution({
    executionId,
    afterSubmit: () => {
      handleClose()
      afterSubmit()
    },
  });

  const { checkMyDispositions, loading: checkingMyDispositions } = useCheckMyDispositions();

  const onFinish = () => {
    navigate('/painel/atendimentos', { replace: true });
  };

  const loading = startingExecution || checkingMyDispositions;

  return (
    <Dialog.Root
      size="md"
      placement="center"
      open
      onOpenChange={onFinish}
      closeOnInteractOutside={false}
    >
      <Portal>
        <CustomDialogBackdrop />
        <Dialog.Positioner>
          <Dialog.Content bg="grayscale.fg" m={3}>
            <Dialog.Body>
              <Text fontSize="xl" textAlign="center" fontWeight={600} my={6} lineHeight={1.2}>
                O que deseja fazer em seguida?
              </Text>

              <Text color="fg.muted" textAlign="center">
                Após iniciar/continuar o atendimento, é necessário que você finalize-o.
              </Text>
            </Dialog.Body>

            <Flex direction="column" p={3} gap={3}>
              <Button
                bg="green.700"
                color="white"
                onClick={onStartExecution}
                loading={loading}
              >
                Iniciar novo atendimento
              </Button>
              <Button
                bg={{ base: { _light: 'blue.700', _dark: 'blue.900' } }}
                color="white"
                onClick={() => checkMyDispositions(executionId)}
                loading={loading}
              >
                Continuar atendimentos pendentes
              </Button>
              <Button
                variant="outline"
                disabled={loading}
                onClick={onFinish}
              >
                Voltar para a lista de atendimentos
              </Button>
            </Flex>

            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default ConfirmNextCampaignExecutionDialog;
